import React, { useState } from 'react'
import _ from 'lodash'
import { Box, Typography } from '@material-ui/core'
import { Loader } from '../../Components'
import { Cards, Toggle } from '../../elements'
import {
  getRequestToggleOptions,
  PROGRAMSREQUESTS,
  ACCOUNTREQUESTS
} from './constant'
import { useStyles } from './style'
import Breadcrumb from '../../Components/Breadcrumbs'
import AllRequests from './AllRequests'
import ProgramsRequests from './ProgramsRequests'

function Requests(props) {
  const classes = useStyles()
  const [selectedToggle, setToggleValue] = useState(PROGRAMSREQUESTS)

  const getRequestData = () => {
    const programDetails = []
    return programDetails
  }

  const renderRequestContent = () => {
    const tableData = getRequestData()
    return (
      <Box>
        <Toggle list={getRequestToggleOptions()} selected={selectedToggle} onChange={setToggleValue} />
        <br />{!props.page && <br />}
        {selectedToggle === ACCOUNTREQUESTS ? <AllRequests page={props.page} columns={props.columns && props.columns('account')} /> : <ProgramsRequests page={props.page} columns={props.columns && props.columns()} />}
      </Box>
    )
  }

  return (
    <Box>
      <Loader loading={props.loading} />
      {props.page ? <div>{renderRequestContent()}</div> :
        <>
          <Breadcrumb />
          <Box className={classes.headerWrapper}>
            <Typography className={classes.title}>Requests</Typography>
          </Box>
          <Cards className={classes.cardWrapper} children={renderRequestContent()} />
        </>
      }
    </Box>
  )
}

export default Requests